module.exports = __webpack_public_path__ + "img/canbadge_square_37mm_trimmark.e05d47d9.png";